import { render, staticRenderFns } from "./homeCollapse.vue?vue&type=template&id=8eaf024c&scoped=true&"
import script from "./homeCollapse.vue?vue&type=script&lang=js&"
export * from "./homeCollapse.vue?vue&type=script&lang=js&"
import style0 from "./homeCollapse.vue?vue&type=style&index=0&id=8eaf024c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaf024c",
  null
  
)

export default component.exports